<template>
  <kst-modal-search
    :module="Model.Module"
    :moduleType="Model.ModuleType.SearchList"
    :searchData="searchData"
    :title="Info.Modal.SearchList.Label"
    :width="1000"
    @init="handleModal_Init"
    @load="handleModal_Load"
    @loaded="handleModal_Loaded"
    @reset="handleModal_Reset"
    @submit="handleModal_Submit"
  >
    <template #search="{ handleInput }">
      <Search
        :searchData="searchData"
        @input="handleInput"
      />
    </template>

    <template #search-result="{ data, userData }">
      <List
        :items="data.StockSpecialPriceList"
        :userData="userData"
        :sellPrice="sellPrice"
      />
   </template>
  </kst-modal-search>
</template>

<script>
import Info from "../StSpInfo.js";
import Model from "../StSpModel.js";

import List from "./StSpScL_List.vue";
import Search from "./StSpScL_Search.vue";

/**
 * flow (how to use):
 * 1. handle Init event, set and do show when needed
 * 2. handle Loaded when needed
 * 3. handle Submit event
 */
export default {
  components: {
    List,
    Search
  },
  props: {
    // field visibility
    sellPrice: Boolean
  },
  data: () => ({
    Info: Info,
    Model: Model,
    searchData: {
      Search: "",
      WarehouseID: null
    },
    getListService: null,
    // func
    hideFunc: null,
    showFunc: null
  }),
  methods: {
    /*** public method ***/

    show(warehouseId, getListService) {
      this.searchData.WarehouseID = warehouseId;
      this.getListService = getListService;
      this.showFunc();

      this.$emit(this.$kst.Enum.Event.Init, this.show);
    },

    /*** by modal ***/

    handleModal_Init(show, hide) {
      this.showFunc = show;
      this.hideFunc = hide;
      this.init_Data();

      this.$emit(this.$kst.Enum.Event.Init, this.show);
    },

    handleModal_Load(loadList) {
      const options = this.getListOptions();
      const config = this.getListService(options);
      loadList(config);
    },

    handleModal_Loaded(data) {
      this.$emit(this.$kst.Enum.Event.Loaded, data.StockList);
    },

    handleModal_Reset(loadList) {
      this.init_Data();
      this.handleModal_Load(loadList);
    },

    handleModal_Submit(selected) {
      this.$emit(this.$kst.Enum.Event.Submit, selected);
      this.hideFunc();
    },
    handleModal_Submit_Success(data) {
      this.$emit(this.$kst.Enum.Event.Submit, data);
      this.hideFunc();
    },

    /*** custom ***/

    getListOptions() {
      return {
        warehouse: this.searchData.WarehouseID,
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.Fields
      };
    },

    init_Data() {
      // searchData
      this.searchData.Search = "";
    }
  }
}
</script>